// extracted by mini-css-extract-plugin
export default {"content":"cqKkmRztV","hostingContainer":"cGnT1D39M"};